var _rect, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToggleInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 147,
    viewBox: "0 0 265 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 146.177,
    rx: 73.0887,
    transform: "matrix(-1 0 0 1 265 0)",
    fill: "#E9E9E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 57.7429,
    transform: "matrix(-1 0 0 1 125.875 14.6182)",
    fill: "white",
    stroke: "url(#paint0_linear_7189_18697)",
    strokeWidth: 0.514286
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7189_18697",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    stopOpacity: 0.0252353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleInactive);
export default __webpack_public_path__ + "static/media/icon-toggle-inactive.8afc648ae292ce4969f02548b16de370.svg";
export { ForwardRef as ReactComponent };